<template>
  <div>
    <Header :user="user" @logout="Logout" />

    <div class="home">
      <Sidebar
        :documents="documents"
        v-if="user"
        @update:item="updateItem"
        :selectedItem="selectedItem"
      />
      <div v-show="!successLogged" class="my-6 px-4" id="cotter-form-container"></div>
      <!--<button
        @click="verifyCotter()"
        id="verify-button"
      >Verify Cotter (null -> go to form / else go to user dashbaord)</button>

      <button @click="getUserData()" id="verify-button">Get User data</button>-->
      <div v-show="successLogged" id="cotter-verify-block"></div>
      <transition name="fade">
        <div class="content-container" v-if="selectedItem">
          <h2 class="content-title p-4">
            {{ selectedItem.name }}
            <sup
              class="content-category italic text-sm"
            >{{ selectedItem.category }}</sup>
          </h2>
          <p class="close" @click="closeContent"></p>
          <div class="content-box p-4" v-html="selectedItem.content"></div>
        </div>
      </transition>
      <div v-if="selectedItem" class="shadowed"></div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import Header from "./Header.vue";

import Cotter from "cotter";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Sidebar,
    Header,
  },
  data() {
    return {
      successLogged: false,
      payload: null,
      payloadString: null,
      validToken: false,
      accessToken: null,
      documents: null,
      user: null,
      selectedItem: null,
    };
  },
  methods: {
    async getUserData() {
      var token = localStorage.getItem("ACCESS_TOKEN");
      await axios
        .get("/api/user", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          this.documents = response.data.documents;
          this.user = response.data.user;
          this.successLogged = true;
          // console.log(response);
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error.response.data);
          }
        });
    },
    async getData(payload) {
      const self = this;
      var token = localStorage.getItem("ACCESS_TOKEN");
      await axios
        .post("/api/login", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          self.getUserData();
          console.log(response);
        })
        .catch((err) => console.log(err));
    },
    verifyCotter() {
      var cotter = new Cotter(process.env.VUE_APP_COTTER_KEY);
      var user = cotter.getLoggedInUser();
      console.log(user);
    },
    updateItem(payload) {
      if (payload) {
        this.selectedItem = payload;
      }
      return;
    },
    closeContent() {
      this.selectedItem = null;
    },
    Logout() {
      this.user = null;
      localStorage.removeItem("ACCESS_TOKEN");
      this.successLogged = false;
      var cotter = new Cotter(process.env.VUE_APP_COTTER_KEY);
      cotter.logOut();
      //message on logout
    },
  },
  mounted() {
    const self = this;
    var cotter = new Cotter(process.env.VUE_APP_COTTER_KEY);
    cotter
      .signInWithLink()
      .showEmailForm()
      .then((payload) => {
        this.successLogged = true;
        this.payload = payload;
        this.accessToken = this.payload.oauth_token.access_token;
        localStorage.setItem("ACCESS_TOKEN", this.accessToken);
        console.log(
          "payload received: ",
          this.payload.oauth_token.access_token
        );
        this.payloadString = JSON.stringify(payload, null, 4);
        self.getData(this.payload);
      })
      .catch((err) => {
        console.log(err);
      });

    this.getUserData();
  },
};
</script>

    <style lang="scss" scoped>
.arrow-black {
  &:hover {
    cursor: pointer;
  }
}
</style>
